import { createSaga } from "../../utils/createSaga";
import { visitsAddRoutine, visitsRoutine } from "../routines/visitsRoutine";

export default function* anamnezSaga() {
  yield createSaga(visitsRoutine, "GET", "api/visits/");
  yield createSaga(visitsAddRoutine, "POST", "api/visits/");
}
